export const GuestActions = {
  SET_VALUE: '@@GUEST/SET_VALUE',
};
